import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "./baseQuery";
import { API_SERVER } from "../utils/urlBack_End";

export const empleadosApi = createApi({
  reducerPath: "empleadosPlanApi",
  baseQuery: baseQuery(`${API_SERVER}/empleados`),
  tagTypes: [
    "Empleados",
    "EmpleadosPlan",
    "EmpleadosPropuesta",
    "EmpleadosTarea",
    "AtributosEmpleado",
    "NotificacionEmpleado",
    "Bitacora",
    "DashboardEmpleado",
    "HistorialAcciones",
    "Contratos",
    "Permisos",
    "Vacaciones",
  ],
  endpoints: (builder) => ({
    getEmpleados: builder.query({
      query: (id) => `/sucursal/${id}`,
      providesTags: ["Empleados"],
    }),
    getBitacorasEmpleado: builder.query({
      query: (rutEmpleado) => `/bitacora/${rutEmpleado}`,
      providesTags: ["Bitacora"],
    }),
    addBitacoraEmpleado: builder.mutation({
      query: (body) => ({
        url: `/bitacora`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Bitacora"],
    }),
    updateBitacoraEmpleado: builder.mutation({
      query: ({ refUsuario, ...body }) => ({
        url: `/bitacora/${refUsuario}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Bitacora"],
    }),
    deleteBitacoraEmpleado: builder.mutation({
      query: ({ rutEmpleado, fecha }) => ({
        url: `/bitacora/${rutEmpleado}`,
        params: {
          fecha,
        },
        method: "DELETE",
      }),
      invalidatesTags: ["Bitacora"],
    }),
    obtenerEmpleadosActivosSucursal: builder.query({
      query: ({ rut, sucursales }) => {
        const params = {};
        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        return {
          url: `/empleadosActivosSucursal/${rut}`,
          method: "GET",
          params,
        };
      },
    }),
    obtenerEmpleadosPorSucursal: builder.query({
      query: ({ rut, sucursales }) => {
        const params = { rut };

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        return {
          url: `/empleadosPorSucursal`,
          method: "GET",
          params,
        };
      },
    }),
    getEmpleadosActivos: builder.query({
      query: ({ id, estado }) => `/empleadoSucursal/${id}/${estado}`,
      providesTags: ["Empleados"],
    }),
    getEmpleado: builder.query({
      query: (id) => `/${id}`,
      providesTags: ["Empleados"],
    }),
    getEmpleadosAdminSucursal: builder.query({
      query: (id) => `/administradores/${id}`,
    }),
    getEmpleadosPlan: builder.query({
      query: (id) => `/empleadoPlan/${id}`,
      providesTags: ["EmpleadosPlan"],
    }),
    getComisionesEmpleado: builder.query({
      query: ({ rut, nombreCompleto }) =>
        `/comisiones/${rut}/${nombreCompleto}`,
    }),
    getEmpleadoPlanPorSucursal: builder.query({
      query: ({ rut, sucursal }) => `/empleadoPlan/${rut}/${sucursal}`,
      providesTags: ["EmpleadosPlan"],
    }),
    getAtributosEmpleado: builder.query({
      query({ id, refSucursal }) {
        return {
          url: `/atributos/${id}`,
          method: "GET",
          params: {
            refSucursal,
          },
        };
      },
      providesTags: ["AtributosEmpleado"],
    }),
    addEmpleadosPlan: builder.mutation({
      query: (body) => ({
        url: `/empleadoPlan`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["EmpleadosPlan"],
    }),
    deleteEmpleadosPlan: builder.mutation({
      query: (id) => ({
        url: `/empleadoPlan/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["EmpleadosPlan"],
    }),
    getEmpleadosPropuesta: builder.query({
      query: (id) => `/empleadoPropuesta/${id}`,
      providesTags: ["EmpleadosPropuesta"],
    }),
    addEmpleadosPropuesta: builder.mutation({
      query: (body) => ({
        url: `/empleadoPropuesta`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["EmpleadosPropuesta"],
    }),
    addHistorialAcciones: builder.mutation({
      query: ({ user, body }) => ({
        url: `/historialAcciones/${user}`,
        method: "POST",
        body,
      }),
    }),
    obtenerUltimasAccionesEmpleado: builder.query({
      query: ({ refEmpleado, refSucursal }) => ({
        url: `/historialAcciones/${refEmpleado}/${refSucursal}/ultimos`,
        method: "GET",
      }),
      providesTags: ["HistorialAcciones"],
    }),
    obtenerUltimaAccionPorEmpleado: builder.query({
      query: (refSucursal) => ({
        url: `/historialAcciones/${refSucursal}`,
        method: "GET",
      }),
      providesTags: ["HistorialAcciones"],
    }),
    obtenerUrlMasVisitada: builder.query({
      query: (refSucursal) => ({
        url: `/historialAcciones/${refSucursal}/url-mas-visitada`,
        method: "GET",
      }),
      providesTags: ["HistorialAcciones"],
    }),
    deleteEmpleadosPropuesta: builder.mutation({
      query: (id) => ({
        url: `/empleadoPropuesta/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["EmpleadosPropuesta"],
    }),

    getEmpleadosTarea: builder.query({
      query: (id) => `/empleadoTarea/${id}`,
      providesTags: ["EmpleadosTarea"],
    }),
    addEmpleadosTarea: builder.mutation({
      query: (body) => ({
        url: `/empleadoTarea`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["EmpleadosTarea"],
    }),
    addEmpleado: builder.mutation({
      query: (body) => ({
        url: `/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Empleados"],
    }),
    getPermisosEmpleado: builder.query({
      query: (rutEmpleado) => `/permisos/${rutEmpleado}`,
      providesTags: ["Permisos"],
    }),

    addPermisoEmpleado: builder.mutation({
      query: (body) => ({
        url: `/permisos`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Permisos"],
    }),

    updatePermisoEmpleado: builder.mutation({
      query: (body) => ({
        url: `/permisosEmpleado`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Permisos"],
    }),

    updateEstadoPermiso: builder.mutation({
      query: (body) => ({
        url: `/permisos`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Permisos"],
    }),

    deletePermisoEmpleado: builder.mutation({
      query: (id) => ({
        url: `/permisos/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Permisos"],
    }),
    // ── Foto de empleado ─────────────────────────────────────
    uploadFotoEmpleado: builder.mutation({
      query: ({ rut, file, refSucursal }) => {
        const formData = new FormData();
        // Orden importa: refSucursal va antes del file para que el parser multipart del backend
        // lo lea sin necesidad de drenar el stream del archivo.
        formData.append("refSucursal", refSucursal);
        formData.append("file", file, `${rut}.jpg`);
        return {
          url: `/${rut}/foto`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: ["Empleados"],
    }),

    deleteFotoEmpleado: builder.mutation({
      query: ({ rut, refSucursal }) => ({
        url: `/${rut}/foto`,
        method: "DELETE",
        body: { refSucursal },
      }),
      invalidatesTags: ["Empleados"],
    }),

    // ── Actualizar empleado  ────────────
    updateEmpleado: builder.mutation({
      query: ({ rut, refSucursal, ...rest }) => ({
        url: `/${rut}`,
        method: "PUT",
        body: { ...rest, refSucursal },
      }),
      invalidatesTags: ["Empleados"],
    }),
    updateRelacionEmpleadoSucursal: builder.mutation({
      query: (body) => ({
        url: `/empleadoSucursal`,
        method: "PUT",
        body,
      }),
    }),
    updateAtributoEmpleado: builder.mutation({
      query: ({ id, refSucursal, atributo }) => ({
        url: `/atributos/${id}`,
        method: "PUT",
        body: {
          refSucursal,
          atributo,
        },
      }),
      invalidatesTags: ["AtributosEmpleado"],
    }),
    updateComisionEmpleado: builder.mutation({
      query: ({ id, comision }) => ({
        url: `/comisiones/${id}`,
        method: "PUT",
        body: { comision },
      }),
    }),
    // Deprecado
    getNotificacionWebPay: builder.query({
      query: (rutEmpleado) => `/notificaciones/${rutEmpleado}`,
      providesTags: ["NotificacionEmpleado"],
    }),
    // Deprecado
    toggleNotificacionWebPay: builder.mutation({
      query: (rutEmpleado) => ({
        url: `/notificaciones/${rutEmpleado}`,
        method: "PUT",
      }),
      invalidatesTags: ["NotificacionEmpleado"],
    }),
    getNotificaciones: builder.query({
      query: ({ rutEmpleado, sucursal }) =>
        `/config-notificaciones/${rutEmpleado}/${sucursal}`,
      providesTags: ["NotificacionEmpleado"],
    }),
    toggleNotificacion: builder.mutation({
      query: ({ rut, tipo, sucursal }) => ({
        url: `/config-notificaciones/${rut}`,
        method: "PUT",
        body: { tipo, sucursal },
      }),
      invalidatesTags: ["NotificacionEmpleado"],
    }),
    updateCambioContrasena: builder.mutation({
      query: (body) => ({
        url: `/cambioContrasena`,
        method: "PUT",
        body,
      }),
    }),
    addRelacionEmpleadoSucursal: builder.mutation({
      query: (body) => ({
        url: `/empleadoSucursal`,
        method: "POST",
        body,
      }),
    }),
    deleteRelacionEmpleadoSucursal: builder.mutation({
      query: ({ rut, sucursal, rol }) => ({
        url: `/empleadoSucursal/${rut}/${sucursal}/${rol}`,
        method: "DELETE",
      }),
    }),
    deleteEmpleadosTarea: builder.mutation({
      query: (id) => ({
        url: `/empleadoTarea/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["EmpleadosTarea"],
    }),

    // Endpoint para el dashboard del empleado
    getResumenTareas: builder.query({
      query: ({ rutEmpleado, fechaInicio, fechaFin, sucursales }) => ({
        url: `dashboard/tareas/${rutEmpleado}`,
        params: {
          ...(fechaInicio && { fechaInicio }),
          ...(fechaFin && { fechaFin }),
          ...(sucursales?.length && { sucursales: sucursales.join(",") }),
        },
      }),
      providesTags: ["DashboardEmpleado"],
    }),
    getResumenPropuestas: builder.query({
      query: ({ rutEmpleado, fechaInicio, fechaFin, sucursales }) => ({
        url: `dashboard/propuestas/${rutEmpleado}`,
        params: {
          ...(fechaInicio && { fechaInicio }),
          ...(fechaFin && { fechaFin }),
          ...(sucursales?.length && { sucursales: sucursales.join(",") }),
        },
      }),
      providesTags: ["DashboardEmpleado"],
    }),
    getProductividadEmpleado: builder.query({
      query: ({ rutEmpleado, fechaInicio, fechaFin, sucursales }) => ({
        url: `dashboard/productividad/${rutEmpleado}`,
        params: {
          ...(fechaInicio && { fechaInicio }),
          ...(fechaFin && { fechaFin }),
          ...(sucursales?.length && { sucursales: sucursales.join(",") }),
        },
      }),
      providesTags: ["DashboardEmpleado"],
    }),
    getRendimientoEmpleado: builder.query({
      query: ({ rutEmpleado, fechaInicio, fechaFin, sucursales }) => ({
        url: `dashboard/rendimiento/${rutEmpleado}`,
        params: {
          ...(fechaInicio && { fechaInicio }),
          ...(fechaFin && { fechaFin }),
          ...(sucursales?.length && { sucursales: sucursales.join(",") }),
        },
      }),
      providesTags: ["DashboardEmpleado"],
    }),
    getActividadSemanalEmpleado: builder.query({
      query: ({ rutEmpleado, fechaInicio, fechaFin, sucursales }) => ({
        url: `dashboard/actividad-semanal/${rutEmpleado}`,
        params: {
          ...(fechaInicio && { fechaInicio }),
          ...(fechaFin && { fechaFin }),
          ...(sucursales?.length && { sucursales: sucursales.join(",") }),
        },
      }),
      providesTags: ["DashboardEmpleado"],
      keepUnusedDataFor: 300,
    }),

    getComparativaEquipoEmpleado: builder.query({
      query: ({ rutEmpleado, fechaInicio, fechaFin, sucursales }) => ({
        url: `dashboard/comparativa-equipo/${rutEmpleado}`,
        params: {
          ...(fechaInicio && { fechaInicio }),
          ...(fechaFin && { fechaFin }),
          ...(sucursales?.length && { sucursales: sucursales.join(",") }),
        },
      }),
      providesTags: ["DashboardEmpleado"],
      keepUnusedDataFor: 300,
    }),

    getTiempoPorClienteEmpleado: builder.query({
      query: ({ rutEmpleado, fechaInicio, fechaFin, sucursales }) => ({
        url: `dashboard/tiempo-por-cliente/${rutEmpleado}`,
        params: {
          ...(fechaInicio && { fechaInicio }),
          ...(fechaFin && { fechaFin }),
          ...(sucursales?.length && { sucursales: sucursales.join(",") }),
        },
      }),
      providesTags: ["DashboardEmpleado"],
      keepUnusedDataFor: 300,
    }),

    getContratoEmpleado: builder.query({
      query: (rutEmpleado) => `/contrato/${rutEmpleado}`,
      providesTags: ["Contratos"],
    }),
    addContratoEmpleado: builder.mutation({
      query: (body) => ({
        url: `/contrato`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Contratos"],
    }),
    deleteContratoEmpleado: builder.mutation({
      query: (id) => ({
        url: `/contrato/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Contratos"],
    }),

    getVacacionesEmpleado: builder.query({
      query: (rutEmpleado) => `/vacaciones/${rutEmpleado}`,
      providesTags: ["Vacaciones"],
    }),

    addVacacionEmpleado: builder.mutation({
      query: (body) => ({
        url: `/vacaciones`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Vacaciones"],
    }),

    updateVacacionEmpleado: builder.mutation({
      query: (body) => ({
        url: `/vacaciones`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Vacaciones"],
    }),

    updateSolicitudVacaciones: builder.mutation({
      query: (body) => ({
        url: `/solicitudVacaciones`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Vacaciones"],
    }),

    deleteVacacionEmpleado: builder.mutation({
      query: (id) => ({
        url: `/vacaciones/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Vacaciones"],
    }),
  }),
});

export const {
  useGetComisionesEmpleadoQuery,
  useGetEmpleadoPlanPorSucursalQuery,
  useGetEmpleadosPlanQuery,
  useGetEmpleadosActivosQuery,
  useObtenerEmpleadosPorSucursalQuery,
  useGetBitacorasEmpleadoQuery,
  useLazyGetBitacorasEmpleadoQuery,
  useAddBitacoraEmpleadoMutation,
  useUpdateBitacoraEmpleadoMutation,
  useObtenerEmpleadosActivosSucursalQuery,
  useLazyObtenerEmpleadosPorSucursalQuery,
  useLazyGetEmpleadosActivosQuery,
  useLazyGetEmpleadosPlanQuery,
  useLazyObtenerEmpleadosActivosSucursalQuery,
  useGetEmpleadosAdminSucursalQuery,
  useDeleteEmpleadosPlanMutation,
  useDeleteBitacoraEmpleadoMutation,
  useAddEmpleadosPlanMutation,
  useAddHistorialAccionesMutation,
  useObtenerUltimaAccionPorEmpleadoQuery,
  useObtenerUltimasAccionesEmpleadoQuery,
  useObtenerUrlMasVisitadaQuery,
  useGetEmpleadosQuery,
  useLazyGetEmpleadosQuery,
  useAddEmpleadoMutation,
  useUploadFotoEmpleadoMutation,
  useDeleteFotoEmpleadoMutation,
  useUpdateEmpleadoMutation,
  useUpdateRelacionEmpleadoSucursalMutation,
  useAddRelacionEmpleadoSucursalMutation,
  useDeleteRelacionEmpleadoSucursalMutation,
  useUpdateCambioContrasenaMutation,
  useGetAtributosEmpleadoQuery,
  useLazyGetAtributosEmpleadoQuery,
  useUpdateAtributoEmpleadoMutation,
  useUpdateComisionEmpleadoMutation,
  useGetEmpleadoQuery,
  useLazyGetEmpleadoQuery,
  useGetResumenPropuestasQuery,
  useLazyGetResumenPropuestasQuery,
  useGetResumenTareasQuery,
  useLazyGetResumenTareasQuery,
  useGetProductividadEmpleadoQuery,
  useLazyGetProductividadEmpleadoQuery,
  useGetRendimientoEmpleadoQuery,
  useLazyGetEmpleadosPropuestaQuery,
  useGetActividadSemanalEmpleadoQuery,
  useLazyGetActividadSemanalEmpleadoQuery,
  useGetComparativaEquipoEmpleadoQuery,
  useLazyGetComparativaEquipoEmpleadoQuery,
  useGetTiempoPorClienteEmpleadoQuery,
  useLazyGetTiempoPorClienteEmpleadoQuery,
  useGetNotificacionWebPayQuery,
  useToggleNotificacionWebPayMutation,
  useGetNotificacionesQuery,
  useToggleNotificacionMutation,
  useGetEmpleadosTareaQuery,
  useAddEmpleadosTareaMutation,
  useDeleteEmpleadosTareaMutation,
  useGetContratoEmpleadoQuery,
  useAddContratoEmpleadoMutation,
  useDeleteContratoEmpleadoMutation,
  useGetPermisosEmpleadoQuery,
  useAddPermisoEmpleadoMutation,
  useUpdatePermisoEmpleadoMutation,
  useUpdateEstadoPermisoMutation,
  useDeletePermisoEmpleadoMutation,
  useGetVacacionesEmpleadoQuery,
  useAddVacacionEmpleadoMutation,
  useUpdateVacacionEmpleadoMutation,
  useUpdateSolicitudVacacionesMutation,
  useDeleteVacacionEmpleadoMutation,
} = empleadosApi;
